import Vue from 'vue'
import VueRouter from 'vue-router'
import Service from './../views/service'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: "service",
        component: Service
    },
    {
        path: '/service',
        name: "service",
        component: Service
    }
]

const router = new VueRouter({
    routes
})

export default router

